import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TeamService } from '../../Services/team.service';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { GSL, RBTeamMember } from '../../Models/Team';
import { VERBIAGE } from 'src/app/config';

@Component({
    selector: 'team-member-add',
    templateUrl: './team-member-edit.component.html',
    styleUrls: ['./team-member-edit.component.scss']
})

export class TeamMemberEditComponent implements OnInit, OnDestroy {
    Member: RBTeamMember; gsl: GSL[];
    profilePic = null; imageSrc = '/assets/images/user_icon.png';

    // Set input masks for form controls
    inputMask = { phone: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] };

    constructor(
        private _shared: SharedService, private _route: ActivatedRoute, private _router: Router,
        private _team: TeamService, private _notify: NotificationService
    ) {
        // Show loader
        this._shared.loadingState = true;
        // Setting up page title
        this._shared.pageTitle = 'Add Member';
        // Set up page controls
        const _this = this;
        this._shared.pageControls = [
            { type: '-icon-', title: 'Previous page', icon: 'arrow_back', action() {
                _this._router.navigate([(_this._shared.getPreviousUrl !== _this._router.url) ? _this._shared.getPreviousUrl : '/dashboard/teammembers']);
            }}
        ];
    }

    async ngOnInit() {
        this._team.getGSL().subscribe(res => {
            this.gsl = <GSL[]>res['result'];
            // Hide loader
            this._shared.loadingState = false;
        });

        const teammemberID = +this._route.snapshot.params.id;
        this.Member = <RBTeamMember>await this._team.getMemberByID(teammemberID);

        if (this.Member.picture) {
            this.imageSrc = this.Member.picture;
        }

        // Hide loader
        this._shared.loadingState = false;
    }

    updateTeamMember(form) {
        if (!form.valid) { return; }
        // Add new Member in database
        this._team.updateTeamMember(form.value).subscribe(res => {
            if (res['status'] === 'OK') {
                // Check if picture is present
                if (!this.profilePic) {
                    this._notify.toastMessage({ color: 'accent', message: form.value.fullName + VERBIAGE.UPDATE_NEW_MEMBER_SUCCESS, duration: 3000 });        
                    this._router.navigate(['/dashboard/teammembers']);
                } else {
                    // On successfull update
                    let picture: FormData = new FormData();
                    picture.append('picture', this.profilePic, this.profilePic.name);
                    this._team.updateTeamMemberProfilePic(this.Member.teammemberID, picture).subscribe(result => {
                        if (result['status'] === 'OK') {
                            this._notify.toastMessage({ color:'accent', message: form.value.fullName + VERBIAGE.UPDATE_NEW_MEMBER_SUCCESS, duration: 3000 });
                            this._router.navigate(['/dashboard/teammembers']);
                        }
                    });
                }
            }
        }, (err) => {
            // Notify user on error.
            this._notify.openDialog({
                color: 'warn', title: VERBIAGE.UPDATE_NEW_MEMBER_FAIL_TITLE, body: VERBIAGE.UPDATE_NEW_MEMBER_FAIL + err.status
            });
        });
    }

    setProfilePic(e) {
        if (e.target.files && e.target.files.length) {
            var reader = new FileReader();
            reader.onload = function (el) {
                this.imageSrc = el.target.result;
            }.bind(this);
            reader.readAsDataURL(e.target.files[0]);
            this.profilePic = e.target.files[0];
        }
    }
    
    ngOnDestroy() {
        // Remove page controls
        this._shared.pageControls = null;
    }
}